// extracted by mini-css-extract-plugin
module.exports = {"list":"gallery-block-module--list--1LzdH","item":"gallery-block-module--item--3hWvF"};